import { ReactComponent as Rocket } from '@public/icons/rocket.svg';
import Icon from '../atoms/Icon';

const IconRocket = (props) => <Icon as={Rocket} {...props} />;

IconRocket.propTypes = Icon.propTypes;

export default IconRocket;
